/*
 * @Author: chenliang
 * @Date: 2020-11-27 10:37:55
 * @LastEditors: chenliang
 * @LastEditTime: 2021-02-02 14:47:01
 * @Description: 首页
 */
/*
 * @Author: chenliang
 * @Date: 2020-11-27 10:37:55
 * @LastEditors: chenliang
 * @LastEditTime: 2021-02-02 14:47:01
 * @Description: 首页
 *//*
 * @Author: chenliang
 * @Date: 2020-11-27 10:37:55
 * @LastEditors: chenliang
 * @LastEditTime: 2021-02-02 14:47:01
 * @Description: 首页
 */ /*
     * @Author: chenliang
     * @Date: 2020-11-27 10:37:55
     * @LastEditors: chenliang
     * @LastEditTime: 2021-02-02 14:47:01
     * @Description: 首页
     */import {
  DefaultPage,
} from './';

export default {
  path: '/',
  name: 'Home',
  childRoutes: [
    { path: 'default-page',
      name: 'Default page',
      component: DefaultPage,
      isIndex: true,
    },
  ],
};



// WEBPACK FOOTER //
// ./src/features/home/route.js